import { render, staticRenderFns } from "./FifsBuyContainer.vue?vue&type=template&id=096f899e&scoped=true&lang=html&"
import script from "./FifsBuyContainer.vue?vue&type=script&lang=js&"
export * from "./FifsBuyContainer.vue?vue&type=script&lang=js&"
import style0 from "./FifsBuyContainer.vue?vue&type=style&index=0&id=096f899e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f899e",
  null
  
)

export default component.exports